(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collect-tab"] && !Shopify.designMode) return;
  try {
    
  class CollectionTabsSection extends HTMLElement {
    connectedCallback() {
      this.#tabs = this.querySelectorAll('[role="tab"]');
      this.#panels = this.querySelectorAll('[role="tabpanel"]');
      this.#tabs.forEach((tab) => tab.addEventListener('click', () => this.#activateTab(tab)));
      this.#panels.forEach((panel) => this.#initCarousel(panel));
    }

    #tabs = [];
    #panels = [];

    #activateTab(tab) {
      const index = tab.dataset.tabIndex;

      this.#tabs.forEach((t) => {
        const isActive = t.dataset.tabIndex === index;
        t.classList.toggle('collect-tab__tab--active', isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.#panels.forEach((panel) => {
        const isActive = panel.dataset.panelIndex === index;
        panel.classList.toggle('collect-tab__panel--active', isActive);
        panel.hidden = !isActive;
        if (isActive) this.#updateCarousel(panel);
      });
    }

    #initCarousel(panel) {
      const track = panel.querySelector('[data-carousel-track]');
      const prev = panel.querySelector('[data-carousel-prev]');
      const next = panel.querySelector('[data-carousel-next]');
      if (!track || !prev || !next) return;

      const update = () => this.#updateCarousel(panel);
      prev.addEventListener('click', () => {
        track.scrollBy({ left: -this.#scrollStep(track), behavior: 'smooth' });
      });
      next.addEventListener('click', () => {
        track.scrollBy({ left: this.#scrollStep(track), behavior: 'smooth' });
      });
      track.addEventListener('scroll', update, { passive: true });
      update();
    }

    #scrollStep(track) {
      const slide = track.querySelector('.collect-tab__card');
      if (!slide) return track.clientWidth;
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return slide.offsetWidth + gap;
    }

    #updateCarousel(panel) {
      const track = panel.querySelector('[data-carousel-track]');
      const prev = panel.querySelector('[data-carousel-prev]');
      const next = panel.querySelector('[data-carousel-next]');
      if (!track || !prev || !next) return;

      const maxScroll = track.scrollWidth - track.clientWidth;
      const scrollLeft = track.scrollLeft;
      prev.disabled = scrollLeft <= 1;
      next.disabled = scrollLeft >= maxScroll - 1;
      prev.classList.toggle('collect-tab__arrow--disabled', prev.disabled);
      next.classList.toggle('collect-tab__arrow--disabled', next.disabled);
    }
  }

  if (!customElements.get('collection-tabs-section')) {
    customElements.define('collection-tabs-section', CollectionTabsSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
